import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChevronLeft,
  faLocationDot,
  faCheck 
} from '@fortawesome/free-solid-svg-icons';
import '../styles/ConferenceRoomDetail.css';

// Mock data - in a real app, this would come from an API
const roomDetails = {
  2: {
    id: 2,
    name: 'Grand Assembly',
    subtitle: 'Grand Assembly',
    capacity: 100,
    squareFeet: 1543,
    image: 'https://worklifepenn1.spaces.nexudus.com/en/publicResources/GetImage?id=1414940262',
    location: '250 W 34th St. 2nd floor',
    price: 1750.00,
    isPaid: true,
    bookingUrl: 'https://worklifepenn1.spaces.nexudus.com/en/bookings/room/1414940262',
    amenities: [
      'Internet',
      'Large Display',
      'Tea And Coffee',
      'Air Conditioning',
      'Natural Light',
      'White Board',
      'Catering',
      'Drinks',
      'Heating'
    ],
    description: 'The Grand Assembly is our largest space (1,543 sq. ft.) that accommodates various meeting setups, with a maximum capacity of 100 people. With the booking of the Grand Assembly, your group will have exclusive use of the Pre-Function Lounge. We provide podiums, easels, flipchart, whiteboard, handheld and lavalier microphones upon request. For Assembly bookings, we require a 25% non-refundable deposit due at the time of booking. The balance is due 10 business days prior to your event date.',
    contactInfo: {
      phone: '917-764-6338',
      email: 'worklifemeetings@industriousoffice.com'
    },
    openingHours: {
      'Sun': 'Closed',
      'Mon': '09:00 AM - 05:00 PM',
      'Tue': '09:00 AM - 05:00 PM',
      'Wed': '09:00 AM - 05:00 PM',
      'Thu': '09:00 AM - 05:00 PM',
      'Fri': '09:00 AM - 05:00 PM',
      'Sat': 'Closed'
    }
  }
};

function ConferenceRoomDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const room = roomDetails[id];

  if (!room) {
    return <div>Room not found</div>;
  }

  return (
    <div className="conference-room-detail">
      {/* Back button */}
      <button className="back-button" onClick={() => navigate('/')}>
        <FontAwesomeIcon icon={faChevronLeft} />
        Back to HqO
      </button>

      {/* Hero Image */}
      <div className="room-hero">
        <img src={room.image} alt={room.name} />
      </div>

      {/* Room Info */}
      <div className="room-info-container">
        <h1>{room.name}</h1>
        <h2>{room.subtitle}</h2>

        {/* Location */}
        <div className="location">
          <FontAwesomeIcon icon={faLocationDot} />
          <span>{room.location}</span>
        </div>

        {/* Amenities */}
        <div className="amenities-section">
          <h3>Amenities</h3>
          <div className="amenities-grid">
            {room.amenities.map((amenity, index) => (
              <div key={index} className="amenity-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{amenity}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Description */}
        <div className="description-section">
          <h3>Description</h3>
          <p>{room.description}</p>
          <p>If you have any questions, please contact WorkLife Meetings at{' '}
            <a href={`tel:${room.contactInfo.phone}`}>{room.contactInfo.phone}</a> or e-mail us at{' '}
            <a href={`mailto:${room.contactInfo.email}`}>{room.contactInfo.email}</a>.
          </p>
        </div>

        {/* Opening Hours */}
        <div className="opening-hours-section">
          <h3>Opening hours</h3>
          <div className="hours-grid">
            {Object.entries(room.openingHours).map(([day, hours]) => (
              <div key={day} className="hours-row">
                <span className="day">{day}</span>
                <span className="hours">{hours}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Additional Info */}
        <div className="additional-info">
          <p>Additional information required for this booking</p>
        </div>

        {/* Booking Summary */}
        <div className="booking-summary">
          <div className="booking-time">
            Apr 24 • 9 - 10 am
          </div>
          <div className="booking-price">
            ${room.price.toFixed(2)}
          </div>
        </div>

        {/* Book Button */}
        <a 
          href={room.bookingUrl} 

          rel="noopener noreferrer" 
          className="book-button"
        >
          Book
        </a>
      </div>
    </div>
  );
}

export default ConferenceRoomDetail; 